import {FACTIONS} from "../../../constants/factions";

export const SUCCUBES_QUOTES = [{
  quote: 'Доверять своему лучнику можно только до тех пор, пока ты смотришь в его сторону',
  author: 'Фабия Обворожительная, суккуб-командир Целованных рот',
  factionId: FACTIONS.SUCCUBES
}, {
  quote: 'Твой лучник нашёл нового командира. С лучшей улыбкой',
  author: 'Меция Торгующая, суккуб-кураторша Списка податливых',
  factionId: FACTIONS.SUCCUBES
}, {
  quote: 'Клинок убеждает тело. Шёпот убеждает душу',
  author: 'Аквилия Двуликая, суккуб-эдил Обманутых надежд',
  factionId: FACTIONS.SUCCUBES
}, {
  quote: 'Я не забираю твоих солдат. Я просто даю им выбор. Выбор между тобой и мной. Странно, как часто они выбирают не тебя',
  author: 'Корнелия Сладкая Смерть, архисуккуб-соблазнительница Нагих скал',
  factionId: FACTIONS.SUCCUBES
}]